import * as yup from "yup";

export const codeValidationSchema = yup.object({
  codigo: yup
    .string()
    .required("Campo obrigatório")
    .min(12, "Código deve possuir 12 caracteres")
    .max(12, "Código deve possuir 12 caracteres")
});

export type CodeValidation = yup.InferType<typeof codeValidationSchema>;
